// tslint:disable-next-line: no-submodule-imports
import useStyles from 'isomorphic-style-loader/useStyles';
import React, { useCallback, useEffect, useState } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import BackgroundImage from '../components/BackgroundImage';
import Lyrics from '../components/Lyrics';
import { WINDOW_SIZE_ENUM } from '../types/IWindowSize';
import { dispatchSkyfireMethods, globals } from '../utils';
import { dispatchPlaybackMethods } from '../utils/dispatchPlaybackMethods';
import * as dialogStyles from './Dialog.scss';
import * as nowPlayingStyles from './NowPlaying.scss';
const { window } = globals;
export default function NowPlaying(props) {
    var _a;
    useStyles(dialogStyles, nowPlayingStyles);
    const dispatch = useDispatch();
    const { npvBackground, title, subTitle, artwork, lyrics, onBackgroundImageRequired, artworkLink, titleLink, subTitleLink, onLyricsRequired, onMediaViewed, mediaId } = useSelector((state) => state.Media);
    const { isTransportOverlayOpen } = useSelector((state) => state.TransportOverlay);
    const { onItemSelected: closeItemSelected } = props.template.closeButton;
    const { windowWidth, windowHeight } = useSelector((state) => state.BrowserState, shallowEqual);
    const windowRatio = windowWidth / windowHeight;
    // Only hide lyrics if we have received a lyrics object back from skyfire and it is empty
    // or the currently playing media does not have a method to retrieve lyrics
    const [shouldShowLyrics, setShouldshowLyrics] = useState(onLyricsRequired.length > 0 && (!lyrics || Object.keys(lyrics.lines).length > 0));
    const [fetchingNpvBackground, setFetchingNpvBackground] = useState(false);
    const [fetchingLyrics, setFetchingLyrics] = useState(false);
    useEffect(() => {
        if (onLyricsRequired.length === 0 && shouldShowLyrics) {
            setShouldshowLyrics(false);
        }
        if (onLyricsRequired.length > 0 && lyrics !== undefined) {
            setShouldshowLyrics(Object.keys(lyrics.lines).length > 0);
        }
    }, [lyrics, mediaId]);
    useEffect(() => {
        setFetchingNpvBackground(false);
    }, [npvBackground, mediaId]);
    useEffect(() => {
        setFetchingLyrics(false);
    }, [lyrics, mediaId]);
    useEffect(() => {
        fetchRequireMedia();
    }, [lyrics, npvBackground, mediaId]);
    useEffect(() => {
        dispatchSkyfireMethods(dispatch, props.template, onMediaViewed);
    }, [mediaId]);
    useEffect(() => {
        dispatchSkyfireMethods(dispatch, props.template, props.template.onViewed);
    }, []);
    useEffect(() => {
        window.addEventListener('keydown', handleEscape);
        return () => window.removeEventListener('keydown', handleEscape);
    }, [isTransportOverlayOpen]);
    const handleEscape = (e) => {
        if (e.key === 'Escape' && !isTransportOverlayOpen) {
            handleSelected(e, props.template.closeButton.onItemSelected);
        }
    };
    const onClose = useCallback((e) => handleSelected(e, props.template.closeButton.onItemSelected), [props.template.closeButton]);
    const onArtworkClick = useCallback((e) => { var _a; return handleSelected(e, (_a = artworkLink) === null || _a === void 0 ? void 0 : _a.onItemSelected); }, [artworkLink]);
    const onTitleClick = useCallback((e) => { var _a; return handleSelected(e, (_a = titleLink) === null || _a === void 0 ? void 0 : _a.onItemSelected); }, [titleLink]);
    const onSubTitleClick = useCallback((e) => { var _a; return handleSelected(e, (_a = subTitleLink) === null || _a === void 0 ? void 0 : _a.onItemSelected); }, [subTitleLink]);
    const handleSelected = (event, methods = []) => {
        var _a;
        (_a = event) === null || _a === void 0 ? void 0 : _a.preventDefault();
        dispatchSkyfireMethods(dispatch, props.template, methods);
    };
    const Header = () => {
        var _a, _b;
        const largeBreakpoint = (windowWidth >= 840 && windowHeight >= 840);
        const headlineClass = largeBreakpoint ? 'music-headline-2' : 'music-primary-text';
        const subTitleClass = largeBreakpoint ? 'music-primary-text' : 'music-secondary-text';
        return (React.createElement("header", null,
            React.createElement("a", { href: (_a = titleLink) === null || _a === void 0 ? void 0 : _a.deeplink, onClick: onTitleClick, id: nowPlayingStyles.headline, className: headlineClass }, title),
            React.createElement("a", { href: (_b = subTitleLink) === null || _b === void 0 ? void 0 : _b.deeplink, onClick: onSubTitleClick, className: subTitleClass }, subTitle)));
    };
    return (React.createElement("div", { className: [dialogStyles.modal, nowPlayingStyles.npv].join(' '), id: "npv" },
        React.createElement("div", { className: nowPlayingStyles.view },
            React.createElement(BackgroundImage, { isNowPlaying: true, src: windowWidth <= WINDOW_SIZE_ENUM.XL2 ? artwork : npvBackground }),
            React.createElement("div", { className: nowPlayingStyles.gradientOverlay }),
            React.createElement("div", { className: nowPlayingStyles.navbar },
                React.createElement("music-button", { className: nowPlayingStyles.closeButton, onmusicActivate: onClose, variant: "glass", size: "medium", "icon-name": "cancel", "icon-only": true, id: "npvCloseButton", ariaLabelText: "Close" })),
            React.createElement(Header, null),
            React.createElement("div", { className: nowPlayingStyles.content },
                React.createElement("div", { className: nowPlayingStyles.artContainer },
                    React.createElement("div", { className: nowPlayingStyles.album },
                        React.createElement("a", { href: (_a = artworkLink) === null || _a === void 0 ? void 0 : _a.deeplink, onClick: onArtworkClick, className: nowPlayingStyles.art, style: { backgroundImage: `url(${artwork})` } }))),
                shouldShowLyrics && React.createElement("div", { className: nowPlayingStyles.lyricsContainer },
                    React.createElement(Lyrics, { lyrics: lyrics }))))));
    function fetchRequireMedia() {
        if (!npvBackground && !fetchingNpvBackground) {
            dispatchPlaybackMethods(dispatch, mediaId, onBackgroundImageRequired);
            setFetchingNpvBackground(true);
        }
        if (!lyrics && !fetchingLyrics) {
            dispatchPlaybackMethods(dispatch, mediaId, onLyricsRequired);
            setFetchingLyrics(true);
        }
    }
}
;
